<template>
  <block-layout-wrapper
    class="font-inter font-light lg:text-md bg-black text-white text-gray-field-light"
    classes="!pt-36">
    <div
      class="flex flex-wrap lg:flex-nowrap gap-6 md:gap-8 lg:gap-6 xl:gap-10 justify-start items-start">
      <div class="flex flex-col gap-10 w-full md:w-full">
        <div class="flex max-w-[200px]">
          <Link href="/">
          <img :src="getImageUrl('logos/logo.svg')"
            class="w-full max-w-full object-contain" />
          </Link>
        </div>
        <span class="w-full sm:w-3/4 lg:w-full">
          Trusted by 400,000+ EMTs nationwide for NREMT test&nbsp;prep
        </span>
        <div class="flex items-center gap-4 mt-4">
          <a v-for="social in socialLinks" :href="social.link"
            class="hover:text-white text-gray-500" target="_blank">
            <img :alt="social.icon + ' icon'" :src="getImageUrl(social.icon)"
              class="opacity-60">
          </a>
        </div>
      </div>
      <div v-for="block in footerBlocks" class="w-full sm:w-[calc(50%-1rem)]">
        <div
          class="font-display font-bold text-xs md:text-base text-white mb-6 text-pretty uppercase whitespace-nowrap  xl:whitespace-nowrap">
          {{ block.title }}
        </div>
        <ul class="flex flex-col gap-6 whitespace-nowrap text-base">
          <li v-for="{ fields } in block.links" class="">
            <Link :href="getUrl(fields)"
              class="hover:underline link hover:text-white text-pretty">
            <span v-html="fields.title" />
            </Link>
          </li>
        </ul>
      </div>
      <div class="w-full sm:w-[calc(50%-1rem)]">
        <div
          class="font-display font-semibold text-xs mb-4 text-white text-pretty uppercase">
          CONNECT WITH
          US
        </div>
        <div class="flex flex-col gap-4">
          <div class="whitespace-nowrap lg:whitespace-normal xl:whitespace-nowrap">
            Have any questions?
          </div>
          <div>
            Send us an email at:
            <a class="underline link text-amber-400 text-danger-light hover:text-white"
              :href="`mailto:${this.$page.props.site_config.support_email}`">{{
                this.$page.props.site_config.support_email }}</a>
          </div>
        </div>
      </div>
    </div>
  </block-layout-wrapper>
</template>

<script>
import BlockLayoutWrapper from "@/Layouts/BlockLayoutWrapper.vue";
import { Link } from "@inertiajs/vue3";

export default {
  name: "FrontendFooter",
  components: {
    Link,
    BlockLayoutWrapper,
  },
  data: function () {
    return {
      footerBlocks: this.$page.props.footer_blocks,
      socialLinks: [
        { link: "https://www.facebook.com/profile.php?id=100063592328116", icon: "facebook.svg" },
        { link: "https://x.com/emtprep", icon: "twitter.svg" },
        { link: "https://www.youtube.com/channel/UCpXn4ToUsD7OmjjH-bmaBjg", icon: "youtube.svg" },
      ],
    };
  },
  methods: {
    getUrl(fields) {
      let url = fields.target === "internal" ? fields.internal_page_url : fields.external_page_url;
      // Ensure URL starts with / for absolute paths
      return url && !url.startsWith("/") && !url.startsWith("http") ? `/${url}` : url;
    }
  }
};
</script>

<style scoped></style>
